import { CommandProvider } from "@/components/command/command-provider";
import { IntegrationProvider } from "@/contexts/IntegrationProvider";
import { UserProvider } from "@/contexts/UserProvider";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { OverlayProvider } from "overlay-kit";

export const Route = createFileRoute("/_authenticated")({
  component: RouteComponent,
  beforeLoad: ({ context: { authentication } }) => {
    if (!authentication?.session) {
      throw redirect({ to: "/login" });
    } else if (!authentication?.session.user.user_metadata.email_verified) {
      throw redirect({ to: "/verify-email" });
    }
  },
});

function RouteComponent() {
  return (
    <UserProvider>
      <IntegrationProvider>
        <OverlayProvider>
          <CommandProvider>
            <Outlet />
          </CommandProvider>
        </OverlayProvider>
      </IntegrationProvider>
    </UserProvider>
  );
}
